import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=0c8d1970&"
import script from "./Datepicker.js?vue&type=script&lang=js&"
export * from "./Datepicker.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports